import React from 'react'
import Listener from '../../core/watcher/Listener'
import OnlineNumberUpdater from '../../core/classes/OnlineNumberUpdater'
import EventEmitterManager from '../../core/event/EventEmitterManager'
import ScrollYPointWatcher from '../../core/watcher/ScrollYPointWatcher'
import Element from '../../core/element/Element'
import {initOfferSlider} from './js/initializer'

import './_style.scss'

Listener.onLoadDOM(() => {
   initOfferSlider()

   new OnlineNumberUpdater({selector: '.js-onlineMarker'})

   const selector = '.offers--single'
   if (document.querySelector(selector)) {
      new ScrollYPointWatcher(
         new Element(document.querySelector(selector)).getBottomPointRelativeToPage() - 110,
         EventEmitterManager.emitScrolledBelowOfferSlider,
         EventEmitterManager.emitScrolledAboveOfferSlider,
      )
   } else {
      console.log('selector "' + selector + '" is NULL')
   }
})